module.exports = __webpack_public_path__ + "static/media/oppløysning.d34e3672.m4a";